import { render, staticRenderFns } from "./PanelTab.vue?vue&type=template&id=1ac079c7&scoped=true&"
import script from "./PanelTab.vue?vue&type=script&lang=js&"
export * from "./PanelTab.vue?vue&type=script&lang=js&"
import style0 from "./PanelTab.vue?vue&type=style&index=0&id=1ac079c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac079c7",
  null
  
)

export default component.exports